import { render, staticRenderFns } from "./infomation.vue?vue&type=template&id=ef00d33a&scoped=true"
import script from "./infomation.vue?vue&type=script&lang=js"
export * from "./infomation.vue?vue&type=script&lang=js"
import style0 from "./infomation.vue?vue&type=style&index=0&id=ef00d33a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef00d33a",
  null
  
)

export default component.exports